
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"37","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#EA983F","stroke-width":"1.25","d":"M.625.625H36.14v28.75H.625z"}}),_c('path',{attrs:{"fill":"#EA983F","d":"M4.326 5H32.44v13.75H4.326z"}}),_c('path',{attrs:{"stroke":"#EA983F","stroke-width":"1.875","d":"M4.326 21.563H32.44M4.326 24.063H32.44"}})])
          )
        }
      }
    